export const styles = {
  wrap: {
    display: 'none',
  },
};
